import classNames from 'classnames'
import React from 'react'

import { IBaseProps } from 'browser/components/atomic-elements/atoms/base-props'
import 'browser/components/atomic-elements/atoms/status-badge/_status-badge.scss'
import { FramesManager } from 'shared-libs/components/view/frames-manager'
import { translateString } from 'shared-libs/helpers/utils'

/**
 * @uiComponent
 */
interface IStatusBadgeProps extends IBaseProps {
  frames?: FramesManager
  text?: string
  color?: string
}

export const StatusBadge: React.FC<IStatusBadgeProps> = (props) => {
  const { frames, text, children, color } = props

  const translationTable = frames?.getContext('translationTable')
  const translatedText = translateString(text, translationTable)
  const content = translatedText || children

  return (
    <div className={classNames('c-badge', color && `c-badge--${color}`)}>
      {content}
    </div>
  )

}
